angular.module('programme')

.directive('bindHtmlTrans', ['programmes', function (programmes) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            scope.$watch(function () {
                return scope.$eval(attrs.bindHtmlTrans);
            }, function (value) {

                if (programmes.current.language && programmes.translations[programmes.current.language.code]) {
                    const trans = programmes.translations[programmes.current.language.code];
                    value = trans[value] || value;
                }

                element.html(value && value.toString());
            });
        }
    };
}]);
